import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ClientService from "../../rest/clientService";

const PagBankAuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        if (code) {
            ClientService.handleCallback(code, state)
                .then(() => {
                    navigate("/cadastro");
                })
                .catch((error) => {
                    console.error("Erro ao processar autenticação:", error);
                    alert("Erro ao processar autenticação.");
                });
        } else {
            console.error("Código ou state ausente na URL.");
        }
    }, [searchParams, navigate]);

    return <h2>Processando autenticação...</h2>;
};

export default PagBankAuthCallback;
